import React from "react";
// import { useNavigate } from "react-router-dom";
import { Offer } from "../utils/API";
import CouponRecommendations from "./couponrecommendations";

const BrandList: React.FC<{ brandListData: Offer[] }> = ({ brandListData }) => {
  // console.log("brandListData ---->", brandListData);
  // const navigate = useNavigate();

  // const handleJumpToBranddiscountcode = (offer_id: string, store: string) => {
  //   navigate(`/branddiscountcode?offer_id=${offer_id}&store=${store}`);
  // };

  return (
    <div className="w-full flex justify-center items-center my-16 md:my-24">
      <div className="w-full category-grocery-and-food-coupons">
        <div className="max-w-[1300px] mx-auto">
          <div
            className="w-full text-center text-2xl font-black leading-6 text-white md:text-3xl md:leading-10 mb-6 md:mb-10 md:text-left px-3.5 md:px-[50px]"
            style={{ textShadow: "0px 4px 1px rgba(50, 0, 0, 0.3)" }}
          >
            BrandList
          </div>
          <CouponRecommendations brandListData={brandListData} />
          {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-5 gap-x-[23px] md:gap-[30px] mx-auto px-[26px] md:px-[100px]">
{brandListData?.map((item) => {
  const logoUrl = (item.brand_logo || "")
    .replace("[size]", "200")
    .replace("[format]", "png");
  return (
    <div
      key={item.offer_id}
      className="coupon-item flex-col shadow-coupon py-2.5 px-3.5 md:py-4 md:px-6 h-[183px] md:h-[220px] lg:h-[250px] xl:h-[300px] cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-[#ef312b33] relative overflow-hidden group"
      style={{
        background:
          "url(/images/discount-bg-m.png) no-repeat center center / 100% 100% ",
      }}
      onClick={() =>
        handleJumpToBranddiscountcode(item.offer_id, item.store)
      }
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/0 via-primary-500/0 to-primary-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      <div className="flex flex-col justify-center items-center gap-5 md:gap-7 lg:gap-10 xl:gap-12">
        <div className="flex justify-center items-center rounded-[10px] transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3 pt-4">
          <img
            src={logoUrl}
            alt={item.categories}
            referrerPolicy="no-referrer"
            crossOrigin="anonymous"
            loading="lazy"
            decoding="async"
            // fetch-priority="auto"
            width="100"
            height="100"
            className="w-[80px] h-[80px] md:w-[90px] md:h-[90px] lg:w-[100px] lg:h-[100px] xl:w-[118px] xl:h-[118px] rounded-[10px] object-contain"
          />
        </div>
         <div className="text-xs leading-4 min-h-[32px] md:text-sm md:min-h-[32px] md:leading-4 lg:text-base lg:leading-5 lg:min-h-[40px] xl:text-xl xl:min-h-[56px] font-bold text-center line-clamp-2 text-textMain-500 opacity-80">
          15%OFF メデマート キャンペーン - 2025年8月{" "}
        </div> 
        <div className="flex flex-col justify-center items-center gap-1 mt-4">
          <div className="text-[26px] leading-8 md:text-[32px] md:leading-9 lg:text-[36px] lg:leading-10 xl:text-[38px] xl:leading-[52px] font-black text-center line-clamp-1 text-white">
            キャンペーン
          </div> 
          <div className="text-[10px] md:text-[13px] md:leading-4 lg:text-sm lg:leading-4 xl:text-base xl:leading-5 font-semibold leading-3 text-center line-clamp-1 text-white">
            {item.title}
          </div>
        </div>
      </div>
    </div>
  );
})}
</div> */}
        </div>
      </div>
    </div>
  );
};

export default BrandList;
